import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { MarkersInfoColors } from "../WinLineInfoMarkers"
// namespace SlotGames {
export class RoyalChalice_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {


    //protected override helpFactory: IHelpFactory = new RoyalChaliceHelpFactory();

    //LED COLOR
    protected override ColorLed: string = "250,0,0\n";

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "RoyalChalice") {
        super(multigameParams, initData, gameName);
        this.spinnableReelsParams.topBorderWidth = 0;
        this.spinnableReelsParams.bottomBorderWidth = 0;
    }

    //SEND COLOR 
    protected override color: RewardColor =
        {
            color: "white",
            coloroutherStroke: "black",
            colorinnerStroke: "red",
        }
    protected override colorLineMarkers: MarkersInfoColors =
    {
        MarkerbackgroundColor: "linear-gradient(to right, #610013 0%, #2e0001 47%, #610013 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)"
    };

}

//Help Colorized
class RoyalChaliceHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new RoyalChaliceHelp(params);
    }
}

class RoyalChaliceHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
// }
